import { useState, useEffect, useRef, useCallback } from "react";
import { serialxd } from "@/Service/SerialImpTerm";
import type { OrderBuyResponse } from "@/Models/Response/OrderBuyResponse";
import type { MCheckout } from "@/Models/MCheckout/MCheckout";
import { DefaultTicket, PrintDataView } from "../Index";
import ModalThankyou from "../Modal/ModalThankYou/ModalThankyou";
import { useNavigate } from "react-router-dom";

type Props = {
  MOrderResponse: OrderBuyResponse[];
  MDatos: MCheckout[];
  PrintTitle: string;
};

export const PrintReceipt = ({
  MOrderResponse,
  MDatos,
  PrintTitle,
}: Props): JSX.Element => {
  //obtenemos los datos para el código de barra.
  const { OrderCode, orderResponse } = MOrderResponse[0] ?? {};

  //Obtenmos los datos del articulo o producto.
  const { quant, totalSalesPrice } = MDatos[0] ?? {};
  //const { name } = MDatos[0]?.productsItem ?? {};
  const name = MDatos[0]?.productsItem?.Name ?? {};

  const orderCode = OrderCode ?? "";
  const total_SalesPrice = totalSalesPrice ?? 0;
  const orderNo = orderResponse?.order_no;
  const nameArticle = String(name) ?? "";

  //loading
  const [isLoading, setIsLoading] = useState(false);
  //fecha
  const [FechaActual, setFechaActual] = useState("");
  //modal
  const [graciasView, setGraciasView] = useState<boolean>(false);
  const timeoutRefThankyou = useRef<number | undefined>(undefined);
  const navigate = useNavigate();

  const TimerRefGracias = useCallback(() => {
    timeoutRefThankyou.current = window.setTimeout(() => {
      setGraciasView(true);
    }, 5000);
  }, []);

  useEffect(() => {
    const loaderSet = () => {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    };
    loaderSet();
    handleDateNow();
    if (!isLoading) {
      codPrint();
    }
  }, [isLoading]);

  useEffect(() => {
    TimerRefGracias();
    return () => clearTimeout(timeoutRefThankyou.current);
  }, [graciasView]);

  const handleDateNow = () => {
    const fechasActual = new Date();
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];

    //nuevo recorrido
    let diasHabiles = 5;
    let contador = 0;
    while (contador < diasHabiles) {
      fechasActual.setDate(fechasActual.getDate() + 1);
      const diasSemana = fechasActual.getDay();
      if (diasSemana !== 0 && diasSemana !== 6) {
        contador++;
      }
    }

    //Acomodar la fecha
    const ano = fechasActual.getFullYear();
    //const mes = String(fechasActual.getMonth() + 1).padStart(2, '0');
    const mes = meses[fechasActual.getMonth()];
    const dia = String(fechasActual.getDate()).padStart(2, "0");

    const fechaSave = `${dia}/${mes}/${ano}`;
    setFechaActual(fechaSave);
  };

  //retirar en domicilio.
  const handdleEnvioDomicilio = [
    {
      nombre: "Iniciar",
      argumentos: [],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["   ¡Gracias por tu compra!\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nArticulo:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [nameArticle],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nCantidad: " + quant],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nTotal de la orden: $" + totalSalesPrice],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nNúmero de pedido: " + orderNo],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nMetodo de entrega:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [PrintTitle],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nPresenta este código de barras"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["impreso al pagar en tienda"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"],
    },
    {
      nombre: "ImprimirCodigoDeBarrasCode128",
      argumentos: ["D387266D", 80, 480, 1], //["D387266D", 80, 380, 0]
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [orderCode],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nEl código tendrá validez solo"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["por 24 hrs. a partir de esta"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["confirmación\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"], // 5 salto de linea
    },
    {
      nombre: "Corte",
      argumentos: [1],
    },
    {
      nombre: "Iniciar",
      argumentos: [],
    },
  ];

  //enviar a tienda.
  const handdleEntIienda = [
    {
      nombre: "Iniciar",
      argumentos: [],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["   ¡Gracias por tu compra!\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nArticulo:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [nameArticle],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nCantidad: " + quant],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nTotal de la orden: $" + totalSalesPrice],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nNúmero de pedido: " + orderNo],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nMetodo de entrega:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [PrintTitle],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nEntrega en:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\nSoriana Híper San Pedro"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nA partir del día:"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [FechaActual],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\nPresenta este código de barras"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["impreso al pagar en tienda"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"],
    },
    {
      nombre: "ImprimirCodigoDeBarrasCode128",
      argumentos: ["D387266D", 80, 480, 1],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: [orderCode],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["El código tendrá validez solo"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["por 24 hrs. a partir de esta"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["confirmación\n\n"],
    },
    {
      nombre: "EscribirTexto",
      argumentos: ["\n\n"], // 5 salto de linea
    },
    {
      nombre: "Corte",
      argumentos: [1],
    },
    {
      nombre: "Iniciar",
      argumentos: [],
    },
  ];

  //print ticket
  const codPrint = async () => {
    const operacionesxd =
      PrintTitle == "Recoger en tienda"
        ? handdleEntIienda
        : handdleEnvioDomicilio;

    //Licencia del plugin para un mes (24/oct/2024 - 23/nov/2024)
    try {
      const cargaUtil = {
        //serial: serialxd,
        serial: "",
        nombreImpresora: "Imp Ticket",
        operaciones: operacionesxd,
      };
      //Usando Plugins de terceros.
      const respuestaHttp = await fetch("http://localhost:8000/imprimir", {
        method: "POST",
        body: JSON.stringify(cargaUtil),
      });
      const respuesta = await respuestaHttp.json();
      if (respuesta.ok) {
        console.log("Impreso correctamente");
      } else {
        console.error(
          "Petición ok pero error en el plugin: " + respuesta.message
        );
      }
    } catch (error) {
      console.log(`[error] : ${error}`);
    }
  };

  const RollBackInit = useCallback(() => {
    setGraciasView(false);
    navigate("/");
  }, []);

  return (
    <>
      {isLoading ? (
        <DefaultTicket />
      ) : (
        <PrintDataView
          names={nameArticle ?? ""}
          quant={quant ?? 0}
          totalSalesPrice={total_SalesPrice}
          orderNo={orderNo ?? ""}
          PrintTitle={PrintTitle}
          FechaActual={FechaActual}
          orderCode={orderCode}
        />
      )}
      {graciasView && (
        <ModalThankyou
          showModal={true}
          titleModal={"Gracias"}
          setViewModal={RollBackInit}
        />
      )}
    </>
  );
};
